import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Address, AddressGroup, checkAddressesForGroupUpdates } from '@mwe/models';
import { EnvironmentService } from '../environment/environment.service';
import { lastValueFrom } from 'rxjs';
import dayjs from 'dayjs';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';

@Injectable({ providedIn: 'root' })
export class AddressGroupService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject(ENVIRONMENT_SERVICE_TOKEN) as EnvironmentService;
  public resourceUrl = this.environmentService.getApiUrl() + 'api/address-group';

  loadAddressGroups(): Promise<AddressGroup[]> {
    return lastValueFrom(this.http.get<AddressGroup[]>(this.resourceUrl + '/allGroups'));
  }

  setAddressGroupName(addressGroup: AddressGroup): Promise<AddressGroup> {
    return lastValueFrom(this.http.post<AddressGroup>(this.resourceUrl, addressGroup, { observe: 'response' })).then(
      res => {
        const address = res.body as AddressGroup;
        address.createdAt = dayjs(address.createdAt).toDate();
        address.modifiedAt = dayjs(address.modifiedAt).toDate();
        address.matchedGroup = true;
        return address;
      },
      err => {
        throw err;
      },
    );
  }

  async deleteAddressGroupName(addressGroup: AddressGroup): Promise<boolean> {
    if (!addressGroup?.id) return false;
    return lastValueFrom(this.http.delete(this.resourceUrl + '/' + addressGroup?.id, { observe: 'response' })).then(
      () => {
        // Success
        return true;
      },
      err => {
        throw err;
      },
    );
  }

  async loadAndMapGroupNames(addresses: Address[]) {
    const addressGroups = await this.getAndUpdateGroupNames();

    return checkAddressesForGroupUpdates(addresses, addressGroups);
  }

  async getAndUpdateGroupNames(): Promise<AddressGroup[]> {
    try {
      return await this.loadAddressGroups();
    } catch (e) {
      return [];
    }
  }
}
